module.exports = __webpack_public_path__ + "static/media/Jayce_0.893d74f8.png";